import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useLocation, useNavigate } from "react-router-dom";
import Editor from "../components/Editor";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { getFirebaseDocs, getUrlParams, randomString } from '../common'
import Header from '../components/Header'
import Tabs from "../components/Tabs";
import Input from "../components/Input";
import MyDropzone from "../components/MyDropzone";
import Dropdown from "../components/Dropdown";

const Activity = () => {


    const emptyExcerpt = '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p><i><strong>See PDF for more info.</strong></i></p>'

    const [confirmDelete, setConfirmDelete] = useState(false)

    const [editId, setEditId] = useState(false)
    const [isAdding, setIsAdding] = useState(false)
    const [name, setName] = useState('')
    const [excerpt, setExcerpt] = useState(emptyExcerpt)
    const [priority, setPriority] = useState(1)
    const [audio, setAudio] = useState('')
    const [audioTitle, setAudioTitle] = useState('')

    const [question, setQuestion] = useState('')
    const [maxCount, setMaxCount] = useState(10)
    const [passCount, setPassCount] = useState(7)

    const [video, setVideo] = useState('')
    const [thumbnail, setThumbnail] = useState('')

    const [loading, setLoading] = useState(false)
    const [mode, setMode] = useState('')
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()

    const [parentsCategories, setParentsCategories] = useState([])

    const userInfo = useSelector(state => state.user.user)


    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                if (!userInfo) {
                    getUserInfo(uid)
                }
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (userInfo && userInfo.role === 'admin') {
            fetchActivity()
        }
    }, [userInfo])

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'users', uid))).data()
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
    }

    const signOutUser = async () => {
        await auth.signOut();
    }

    const fetchActivity = async () => {
        const params = getUrlParams()
        if (!params || !params.subcategory) {
            navigate('/')
            return
        }
        const categoryInfo = await (await getDoc(doc(db, 'learn-subcategories', params.subcategory))).data()

        setMode(categoryInfo.name)
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'learn-activities'), where('parentId', '==', params.subcategory), orderBy('priority', "desc"))))
        setParentsCategories(docs)
    }

    const saveCategory = async () => {
        const params = getUrlParams()
        if (editId) {
            await setDoc(doc(db, 'learn-activities', editId), { name, audio: audio || '', audioTitle: audioTitle || '', parentId: params.subcategory, excerpt, video, thumbnail, priority: parseInt(priority), question, maxCount: parseInt(maxCount), passCount: parseInt(passCount) })
        } else {
            await addDoc(collection(db, 'learn-activities'), { name, audio: audio || '', audioTitle: audioTitle || '', parentId: params.subcategory, excerpt, video, thumbnail, priority: parseInt(priority), question, maxCount: parseInt(maxCount), passCount: parseInt(passCount) })
        }
        setEditId('')
        setIsAdding(false)
        fetchActivity()
    }

    const goBack = () => {
        const canGoBack = location.key !== 'default';
        if (canGoBack) {
            navigate(-1)
        } else {
            navigate('/')
        }
    }



    const deleteActivity = async () => {
        if (editId) {
            if (!confirmDelete) {
                setConfirmDelete(true)
                return
            }
            await deleteDoc(doc(db, 'learn-activities', editId))
            setConfirmDelete(false)
            window.location.reload()
        }
    }

    const handlePaste = () => {
        const item = window.localStorage.getItem('mini-monstars-learn-copy')
        if (!item) {
            toast.error('No item copied')
            return
        }
        let itemPayload = JSON.parse(item)
        setPriority(itemPayload.priority);
        setName(itemPayload.name);
        setThumbnail(itemPayload.thumbnail);
        setVideo(itemPayload.video);
        setExcerpt(itemPayload.excerpt);
        setQuestion(itemPayload.question || '');
        setMaxCount(itemPayload.maxCount || 10);
        setPassCount(itemPayload.passCount || 7);
        setAudio(itemPayload.audio)
        setIsAdding(true);
        setEditId('')
    }

    return <div className="container">
        <Header />
        {isAdding ? <>
            <h2>{editId ? 'Edit' : 'Add'} a {mode} Activity</h2>
            <Input bold type={'text'} errorMessage={''} errors={[]} name={'name'} value={name} setValue={setName} label={'Name'} />


            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Video</label>
            <MyDropzone allowVideo storageLocation={`Activities/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'video'} image={video} updateImage={(doc) => setVideo(doc)} />

            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Thumbnail</label>
            <MyDropzone storageLocation={`Activities/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'thumbnail'} image={thumbnail} updateImage={(doc) => setThumbnail(doc)} />

            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Audio</label>
            <MyDropzone storageLocation={`Activities/${randomString()}`} allowAudio customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'thumbnail'} image={audio} updateImage={(doc) => setAudio(doc)} />

            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Audio Title</label>
            <MyDropzone storageLocation={`Activities/${randomString()}`} allowAudio customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'icon'} image={audioTitle} updateImage={(doc) => setAudioTitle(doc)} />


            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Excerpt</label>
            <Editor data={excerpt} setData={setExcerpt} />

            <Input bold type={'text'} errorMessage={''} errors={[]} name={'priority'} value={priority} setValue={setPriority} label={'Priority'} />

            <Input bold type={'text'} errorMessage={''} errors={[]} name={'question'} value={question} setValue={setQuestion} label={'Question'} />
            <Input bold type={'text'} errorMessage={''} errors={[]} name={'maxCount'} value={maxCount} setValue={setMaxCount} label={'Maximum Count'} />
            <Input bold type={'text'} errorMessage={''} errors={[]} name={'passCount'} value={passCount} setValue={setPassCount} label={'Pass Count'} />

            <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                <button disabled={!name || !excerpt || !video || !priority || !parseInt(priority)} onClick={saveCategory}>Save</button>
                <button style={{ margin: '20px auto' }} className="textButton" onClick={() => { setIsAdding(false); setEditId('') }}>Cancel</button>
                <button disabled={!editId} style={{ backgroundColor: 'red' }} onClick={deleteActivity}>{confirmDelete ? 'Confirm Delete' : 'Delete'}</button>
            </div>

        </> : <>
            {/* <Tabs tabs={modes} currentTab={mode} setCurrentTab={setMode} /> */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button className="textButton" style={{ marginLeft: '0' }} onClick={goBack}> {'←Back'}</button>
                <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => { setIsAdding(true); setEditId(''); setExcerpt(emptyExcerpt) }}>+ Add New</button>
            </div>

            {!isAdding && <button className="textButton" style={{ marginLeft: 'auto' }} onClick={handlePaste}>Paste</button>}

            <h2>{mode} Activities</h2>
            <table>
                <thead>
                    <tr>
                        <th>
                            Name
                        </th>
                        <th>
                            Thumbnail
                        </th>
                        <th>
                            Priority
                        </th>
                        <th>
                            action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {parentsCategories.map(({ id, name, audio, video, excerpt, priority, thumbnail, question, passCount, maxCount }) => <tr key={id}>
                        <td>
                            {name}
                        </td>
                        <td>
                            <img src={thumbnail} style={{ height: '150px' }} />
                        </td>
                        <td>
                            {priority}
                        </td>

                        <td>
                            <div style={{ display: 'flex' }}>
                                {/* <button className="textButton" onClick={() => navigate(`/categories?category=${id}`)}>View</button> */}
                                <button className="textButton" onClick={() => { setIsAdding(true); setEditId(id); setPriority(priority); setName(name); setThumbnail(thumbnail); setVideo(video); setExcerpt(excerpt); setQuestion(question || ''); setMaxCount(maxCount || 10); setPassCount(passCount || 7); setAudio(audio) }}>Edit</button>
                                <button className="textButton" onClick={() => {

                                    window.localStorage.setItem('mini-monstars-learn-copy', JSON.stringify({
                                        name,
                                        priority,
                                        thumbnail,
                                        video,
                                        excerpt,
                                        question,
                                        maxCount,
                                        passCount,
                                        audio,
                                    }))

                                    // setEditId(''); setPriority(priority); setName(name); setThumbnail(thumbnail); setVideo(video); setExcerpt(excerpt); setQuestion(question || ''); setMaxCount(maxCount || 10); setPassCount(passCount || 7); setAudio(audio)
                                }}>Copy</button>
                            </div>
                        </td>

                    </tr>)}
                </tbody>
            </table>
        </>}
    </div>
}

export default Activity